// extracted by css-extract-rspack-plugin
export default {"indeterminate":"indeterminate-eaAY64","slide":"slide-U_vLkj"};